<template>
  <div
    class="grid-container fluid mt-3"
    v-if="authUser.account_type == 'admin' || authUser.account_type == 'worker' || authUser.account_type == 'worker-v2' || authUser.account_type == 'basic'"
  >
    <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell medium-4">
        <OrdersSearchInput @on-search="fetchOrders()" />
      </div>
      <div class="cell medium-5 medium-offset-2">
        <OrdersGridFilters @on-filter="fetchOrders()" @clear-filters="clearFilter()" />
      </div>
      <div class="cell small-12">
        <!-- <OrdersGrid :orders="orders"/> -->
        <div class="stats" v-if="isSabrina">
          <div v-if="orders.length > 0">
            <strong>New Orders (today): {{ today_order_count }}</strong>
          </div>
          <div v-if="orders.length > 0">
            <strong>Orders Edited (today): {{ today_orders_edited }}</strong>
          </div>
        </div>
        <OrdersTable :orders="orders" v-if="orders.length > 0" />
        <AdminActionButtons />
      </div>
      <div class="cell small-12 text-xs-center">
        <strong>Page #{{ currentPage }}</strong>
        <br />
        <v-btn color="red lighten-1" dark @click="fetchNewOrderPage('prev')">Previous</v-btn>
        <v-btn color="red lighten-1" dark @click="fetchNewOrderPage('next')">Next</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AdminActionButtons from "../../components/admin/AdminActionButtons.vue";
import OrdersGrid from "../../components/orders/OrdersGrid.vue";
import OrdersTable from "../../components/orders/OrdersTable.vue";
import OrdersGridFilters from "../../components/orders/OrdersGridFilters.vue";
import OrdersSearchInput from "../../components/orders/OrdersSearchInput.vue";

export default {
  components: {
    AdminActionButtons,
    OrdersGrid,
    OrdersTable,
    OrdersGridFilters,
    OrdersSearchInput
  },
  created() {
    if(this.authUser.account_type != "basic") {
      this.fetchOrders();
    }
  },
  data() {
    return {
      loadingOrders: false,
      nextPage: null,
      totalPages: null,
      currentPage: 1,
      today_order_count: null,
      today_orders_edited: null
    };
  },
  computed: {
    ...mapGetters({
      orders: "ordersGridItems",
      authUser: "authUser"
    }),
    isSabrina() {
      return this.authUser.id == 5387 || this.authUser.id == 1243
        ? true
        : false;
    }
  },
  methods: {
    ...mapActions(["fetchOrdersGridItems"]),
    fetchOrders() {
      let payload = {
        query: this.$route.query.search,
        dates: this.$route.query.dates
          ? this.$route.query.dates.split(",")
          : null,
        method: this.$route.query.method,
                checkpoint: this.$route.query.checkpoint,
        page: 1
      };
      this.loadingOrders = true;
      this.fetchOrdersGridItems(payload).then(response => {
        this.loadingOrders = false;
        this.today_order_count = response.additional.today_order_count;
        this.today_orders_edited = response.additional.today_orders_edited;
        this.currentPage = response.meta.current_page;
        this.nextPage = response.meta.current_page + 1;
        this.totalPages = response.meta.last_page;
      });
    },
    fetchNewOrderPage(button) {
      let payload = {
        query: this.$route.query.search,
        method: this.$route.query.method,
                checkpoint: this.$route.query.checkpoint,
        dates: this.$route.query.dates
          ? this.$route.query.dates.split(",")
          : null,
        page: button == "next" ? this.nextPage : this.currentPage - 1
      };
      this.loadingOrders = true;
      this.fetchOrdersGridItems(payload).then(response => {
        this.loadingOrders = false;
        this.$router.push({
          query: Object.assign({}, this.$route.query, {
            page: response.meta.current_page
          })
        });
        this.currentPage = response.meta.current_page;
        this.nextPage = response.meta.current_page + 1;
        this.totalPages = response.meta.last_page;
      });
    },
    clearFilter() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: 1 })
      });
      this.$router.push({
        query: Object.assign({}, this.$route.query, { search: "" })
      });
      this.$router.push({
        query: Object.assign({}, this.$route.query, { method: "" })
      });
      this.$router.push({
        query: Object.assign({}, this.$route.query, { dates: "" })
      });
      this.fetchOrders();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


